export const ApiRoutes = {
  Authentication: {
    GetAuthenticationRedirectUrl: '/Home/GetAuthenticationRedirectUrl'
  },
  Config: {
    GetConfig: '/Home/GetConfig'
  },
  Client: {
    GetClients: '/api/client/clients',
    GetClientDetail: '/api/client/client',
  },
  Clinician: {
    GetClinicianList: '/api/clinician/clinicians',
    GetClinicianDetail: '/api/clinician/clinician',
    UpdateClinicianDetails: '/api/clinician/clinician',
  },
  Localizer: {
    GetLocalizedStrings: '/api/localization/strings',
  },
  Login: {
    PostLocalLogin: '/Login/LocalLogin',
    GetSession: '/Login/GetUserSession',
    Logout: '/api/login/logout'
  },
  Patient: {
    GetPatientsList: '/api/patient/patients',
    GetPatientDetail: '/api/patient/patient',
    UpdatePatientProfile: '/api/patient/patient',
    UpdatePatientProcedure: '/api/patient/procedure',
    ResendActivationSms: '/api/patient/resend-activation-sms'
  },
  Invite: {
    GetInvitesList: '/api/invite/invites',
    GetInviteDetail: '/api/invite/invite',
    ResendInvite: '/api/invite/invite-resend'
  },
  SupportAgent: {
    GetSupportAgentsList: '/api/supportagent/agents',
    GetSupportAgent: '/api/supportagent/agent',
    GetNewSupportAgent: '/api/supportagent/agent-new',
    UpsertSupportAgent: '/api/supportagent/agent',
  },
  User: {
    GetUserChangeLog: '/api/user/change-log',
    GetAntiForgeryToken: '/api/user/antiforgery'
  },
  ZBEdgeUser: {
    GetUsersList: '/api/zbedgeuser/users',
    GetUser: '/api/zbedgeuser/user',
    UpdateUser: '/api/zbedgeuser/user'
  }
}
